import { Col, FormInstance, Input, Layout, message, Row } from 'antd';
import { useEffect, useState } from 'react';
import AddButton from '../../Molecules/AddButton/AddButton';
import UserTable from '../../Organisms/UserTable/UserTable';
import UserModal from '../../Organisms/UserModal/UserModal';
import { ReactComponent as UserAdd } from '../../../res/svg/user-add.svg';
import User from '../../../models/User';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { ReactComponent as SearchOutlined } from '../../../res/svg/search.svg';
import { createUser, deleteUser, getUsers, setInputSearchUser, selectInputSearchUser} from '../../../store/slice/userSlice';
import './UsersTemplate.less';
import { getRoles } from '../../../store/slice/rolSlice';
import { permissionProfileAdmin, userSubMenu } from '../../../utils/functions';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../Organisms/Navbar/Navbar';
import SectionIndicator, { subsections } from '../../Molecules/SectionIndicator/SectionIndicator';

/**
 * @page UsersTemplate.tsx
 * @description Template to list users.
 * @return { template }
 */
function UsersTemplate() {
  const dispatch = useAppDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [users, setUsers] = useState<User[]>([]);
  const [roles, setRoles] = useState([]);
  const [userFilterList, setUserFilterList] = useState<User[]>([]);
  const userInput:string = useAppSelector(selectInputSearchUser);
  let navigate = useNavigate();

  const showModal = (show: boolean) => {
    setIsModalVisible(show);
  };
  const isHidden = (hidden: boolean) => {
    setIsModalVisible(hidden);
  };
  const getRolesUser = () => {
    dispatch(getRoles()).then((value: any) => {
      if (value.payload.status) {
        let rolData = value.payload.data;
        setRoles(rolData);
      } else {
        setRoles([]);
      }
    });
  };
  const userValue = (user: User, form: FormInstance) => {
    user.notifProcesador = true;
    user.accesoAdministracion = user.tipo.includes('accesoAdministracion') ? true : false;
    user.accesoGestion = user.tipo.includes('accesoGestion') ? true : false;
    user.accesoCatastro = user.tipo.includes('accesoCatastro') ? true : false;
    user.accesoRegistros = user.tipo.includes('accesoRegistros') ? true : false;
    dispatch(createUser(user)).then((value: any) => {
      if (value.payload.status) {
        value.payload.data.rol = value.payload.data.rolId
          ? roles.find((x: any) => x.id === value.payload.data.rolId)
          : {};
        //Actualizar data de la tabla
        getUsersTemplate();
        isHidden(false);
        setIsModalVisible(false);
        form.resetFields();
        message.success('Usuario creado con exito!');
      } else {
        if(value.payload.data.message.includes('duplicate key value')){
          message.error('Este DNI ya ha sido asignado a otro usuario, Por favor ingresa uno diferente.');
        } else {
          message.error(`Error : ${value.payload.data.message}`);
        }
        isHidden(true);
        setIsModalVisible(true);
      }
    });
  };
  const userDeleted = (user: User) => {
    if (user.id !== undefined) {
      dispatch(deleteUser(user)).then((value: any) => {
        if (value.payload.status) {
          let newUserUpdate = userFilterList;
          let findUserUpdate = newUserUpdate.findIndex((x) => x.id === user.id);
          newUserUpdate.splice(findUserUpdate, 1);
          setUserFilterList([...newUserUpdate]);
          message.success('Usuario eliminado con exito.');
        } else {
          message.error('Error: Usuario ligado a una tarea.');
        }
      });
    }
  };

  const getUsersTemplate = () =>{
    dispatch(getUsers()).then((value: any) => {
      if (value.payload.status) {
        setUsers(value.payload.data);
        setUserFilterList(value.payload.data);
      } else {
        setUsers([]);
        setUserFilterList([]);
      }
    });
  }

  const userUpdate = (_userEdit: User) => {
    let newUserUpdate = userFilterList;
    let findUserUpdate = newUserUpdate.findIndex((x) => x.id === _userEdit.id);
    newUserUpdate[findUserUpdate] = _userEdit;
    setUserFilterList([...newUserUpdate]);
  };
  useEffect(() => {
    //solo perfil admin pueden ingresar
    permissionProfileAdmin(navigate);
    getRolesUser();
    dispatch(setInputSearchUser(''));
    getUsersTemplate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (userInput) {
      const filteredData = userFilterList.filter(
        (entry) =>
          entry.nombre!.toLowerCase().includes(userInput.toLowerCase()) ||
          entry.apellido!.toLowerCase().includes(userInput.toLowerCase()),
      );
      setUsers(filteredData);
    } else {
      setUsers([...userFilterList]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userFilterList]);

  const itemsCallback = (item: string) => {
    userSubMenu(item, navigate, dispatch);
  };

  return (
    <Layout>
      <Navbar subsection={'admin'} currentScreen={'admin/usuarios'} showItems={true} itemsCallback={itemsCallback} />
      <SectionIndicator subsection={subsections.usuarios} />
      <Layout className='tp-users-main'>
        <Row>
          <Col span={21}>
            <Input
              className='tp-users-search-input'
              placeholder='Buscar usuario'
              prefix={<SearchOutlined />}
              allowClear
              size='large'
              value={userInput}
              onChange={(e) => {
                const currValue = e.target.value;
                dispatch(setInputSearchUser(currValue));
                if (currValue !== '') {
                  const filteredData = userFilterList.filter(
                    (entry) =>
                      entry
                        .nombre!.toLowerCase()
                        .includes(currValue.toLowerCase()) ||
                      entry
                        .apellido!.toLowerCase()
                        .includes(currValue.toLowerCase()) ||
                      entry.dni?.toLowerCase().includes(currValue.toString().toLowerCase()) ||
                      entry.email?.toLowerCase().includes(currValue.toString().toLowerCase()),
                  );
                  setUsers(filteredData);
                } else {
                  setUsers(userFilterList);
                }
              }}
            />
          </Col>
          <Col span={3}>
            <AddButton
              icon={<UserAdd />}
              title='Crear usuario'
              showModal={showModal}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <UserModal
              buttonText='Crear usuario'
              user={{}}
              setUser={userValue}
              isModalVisible={isModalVisible}
              isHidden={isHidden}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <UserTable
              userList={users}
              userDeleted={userDeleted}
              userUpdate={userUpdate}
              updatedListUser={getUsersTemplate}
            />
          </Col>
        </Row>
      </Layout>
    </Layout>
  );
}

export default UsersTemplate;
